// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__d_V2D","content":"SubHeader_content__1KiV-","btnBack":"SubHeader_btnBack__2hKiC","line":"SubHeader_line__ywqFX"};